import { render, staticRenderFns } from "./setSpecValueDialog.vue?vue&type=template&id=2d16e4d8&scoped=true"
import script from "./setSpecValueDialog.vue?vue&type=script&lang=js"
export * from "./setSpecValueDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d16e4d8",
  null
  
)

export default component.exports